<template>
    <table class="grid">
        <tr>
            <td width="100">
                <span :class="{highlight: diffTitleValue !== ''}"><v-select v-model="diffTitleValue"
                          :options="[
                            { value:'', text: '\u00a0' },
                            ...classFilterOptions
                          ]" /></span>
            </td>
            <td>
                <input type="text" v-model="diffValue" disabled>
            </td>
        </tr>
    </table>
</template>

<script>
    export default {
        name: "DiffFilter",
        props: {
            classFilter: { type: String, default: '' },
            value: {
              default: ''
            }
        },
        data() {
            return {
                classMap: {
                    Doctor: [
                        'Пол', 'Инфо', 'Фамилия', 'Имя', 'Отчество',
                        'URL', 'Специальность', 'Степень', 'Звание',
                        'Категория', 'Цена', 'Цена (Мод)', 'Стаж',
                        'Фото', 'Инфо', 'Образование', 'Опыт',
                        'Сертификаты', 'Ассоциации', 'Клиники', 'Цена приёма'
                    ],
                   ConsultQuestion: [
                        'Специальность', 'Заголовок', 'Текст',
                        'Статус', 'Причина', 'Удалён',
                    ],
                    Document: [
                        'Клиника', 'Название',
                        'Файл', 'Удалён',
                    ],
                    Review: [
                        'Удалён', 'Клиника', 'Врач', 'Автор', 'Рейтинг',
                        'Месторасположение', 'Персонал', 'Цена', 'Комфорт',
                        'Посоветуете', 'Достоинства', 'Недостатки', 'Общее',
                        'Опубликовано', 'Тип отзыва', 'URL',
                    ],
                    Showcard: [
                        'Действует', 'Врач',
                        'Вкл', 'Тип',
                    ],
                    Service: [
                        'Тип','Название',
                        'Категория','URL',
                        'Описание','Коды НМУ',
                        'Врачи спец.'
                    ],
                    Clinic: [
                        'Название', 'Оф. назв.', 'Аватарка', 'ФИО гл. врач',
                        'Год осн.', 'По страховке', 'Опл. картой', 'Лаборатория',
                        'Парковка', 'Стационар', 'url', 'АО', 'Менеджер', 'Адрес',
                        'Карта', 'Телефон', 'Телефон Calltouch', 'Тел. внешний', 'Тел. партнера',
                        'Тел. рег.', 'email', 'Сайт', 'Вконтакте', 'Facebook',
                        'Instagram', 'Одноклассники', 'Канал YouTube', 'Время работы',
                        'Форма собст.', 'Возраст огр.', 'Инфо', 'Фото', 'Номер лиц.',
                        'Лицензии', 'Модерация', 'Метро', 'Метро поиска', 'Категории',
                        'Сервисы', 'Сеть', 'Город', 'Нас. пункт', 'Район', 'Округ',
                        'Удален',
                        'АО Кому имя', //'reportToName',
                        'АО Кому email', //'reportTo',
                        'АО Копия email', //'reportCc',
                        'АО Текст сообщения', //'reportMessage',
                    ],
                },
                diffTitleValue: this.value,
                diffValue: '',
            }
        },
        methods: {
        },
        computed: {
          classFilterOptions: function () {
            let result = [];
            let optionsMap = this.classMap[this.classFilter];
            if (optionsMap) {
              optionsMap.forEach((item) => {
                let optionObject = {
                  value: item,
                  text: item,
                };
                result.push(optionObject);
              });
            }
            return result;
          }
        },
        watch: {
            classFilter() {
                this.diffTitleValue = '';
                this.$emit('input', this.diffTitleValue);
            },
          diffTitleValue() {
              this.$emit('input', this.diffTitleValue);
            }
        },
    }
</script>
